import React, { useState, useRef, useEffect } from 'react'

import Field from '../../Field/Field'
import TextInput from '../../TextInput/TextInput'
import Textarea from '../../Textarea/Textarea'
import Tooltip from '../../Tooltip/Tooltip'
import FieldLabel from '../../FieldLabel/FieldLabel'
import Checkbox from '../../Checkbox/Checkbox'
import Help from '../../Help/Help'
import { fieldUidRegex, getContentTypeFieldDataTestId, CONTENT_TYPE_FIELD_ACTION_IDS, NonLocalizableDom, handleToggleClick } from '../helper'
import ToggleSwitch from '../../ToggleSwitch/ToggleSwitch'
import { booleanTestIdFormatter } from './../../../utils/helpers'
import GroupFieldTitleToggle from "../HelperComponents/GroupFieldTitleToggle"
import CustomUserLimit from './CustomUserLimit'
import ModularBlockInstanceTitleToggle from "../HelperComponents/ModularBlockInstanceTitleToggle"
import GlobalFieldTitleToggle from "../HelperComponents/GlobalFieldTitleToggle"

export const onNumberOptionsChangeMultipleHelper = (schema: any, checked: boolean) => {
  schema.multiple = checked;

  if (!checked) {
    if (schema.hasOwnProperty('min_instance')) {
      delete schema.min_instance;
    }
    if (schema.hasOwnProperty('max_instance')) {
      delete schema.max_instance;
    }

    if (schema.error && schema.error_details) {
      if (schema.error_details.hasOwnProperty('min_instance')) {
        delete schema.error_details.min_instance;
      }
      if (schema.error_details.hasOwnProperty('max_instance')) {
        delete schema.error_details.max_instance;
      }
    }
  } else {
    schema.error_details = {
      ...schema.error_details,
      max_instance: '',
      min_instance: ''
    };
  }

  schema.error =
    schema.error_details &&
    Object.keys(schema.error_details).filter((key) => schema.error_details[key]?.length).length
      ? true
      : false;
};

export const handleKeyDown = (event, value) => {
  event.stopPropagation()
  if (value && (event.key === '-' || event.key === '+')) {
    event.preventDefault()
  }
}

const getParseFloatValue = (value) => {
  if (value === null || value === undefined) {
    return null;
  }
  const parsedValue = parseFloat(value) || null;
  if (parseFloat(value) === 0 && parsedValue === null) {
    return 0;
  }
  return parsedValue;
}

export const Number = (props: any) => {
  const {
    onChange,
    options,
    parentInfo,
    uniqueKey,
    schema,
    type,
    isNonLocalizable,
    hasNonLocalizablePlan,
    hasNonLocalizablePlanForBlocksAndGroupMultiple,
    isCTBuilder,
    userCustomFieldLimits = { hasUserCustomFieldLimit: false, hasUserCustomFieldLimitRestFields: false },
    contentTypeSchemaTree,
    isGlobalFieldBuilderPage
  } = props
  const { hasUserCustomFieldLimit, hasUserCustomFieldLimitRestFields } = userCustomFieldLimits
  const [initialSchema, setSchema] = useState(schema)
  const { display_name, uid, field_metadata } = schema
  const [error, setError] = useState(fieldUidRegex(schema.uid, schema))

  const displayNameRef: any = useRef(null)

  useEffect(() => {
    displayNameRef?.current?.focus()
  }, [displayNameRef])

  const onchange = () => {
    onChange && onChange(schema)
    setSchema({ ...schema })
  }
  const onDisplayNameChange = (event: any) => {
    schema.display_name = event.target.value

    if (schema.hasOwnProperty('display_name') && schema.newfield) {
      schema.uid = schema.display_name
        .trim()
        .replace(/[^A-Z0-9]+/gi, '_')
        .toLowerCase()
      if (schema.display_name) {
        schema.error_details = {
          ...schema.error_details,
          uid: ''
        }
      }
    }

    if (!schema.error_details) {
      schema.error_details = {}
    }

    if (!schema.display_name.length) {
      schema.error_details = {
        ...schema.error_details,
        display_name: 'Display Name cannot be empty'
      }
      schema.error = true
    } else {
      schema.error_details = {
        ...schema.error_details,
        display_name: ''
      }
      schema.error = Object.keys(schema.error_details).filter((fi) => schema.error_details[fi].length).length
        ? true
        : false
    }
    onchange()
  }
  const onUidChange = (event: any) => {
    setError(fieldUidRegex(event.target?.value?.trim(), schema))

    if (!schema.error_details) {
      schema.error_details = {}
    }

    if (!schema.uid.length) {
      schema.error_details = {
        ...schema.error_details,
        uid: 'uid cannot be empty'
      }
      schema.error = true
    } else {
      schema.error_details = {
        ...schema.error_details,
        uid: ''
      }
      schema.error = Object.keys(schema.error_details).filter((fi) => schema.error_details[fi].length).length
        ? true
        : false
    }
    onchange()
  }
  const onPlaceholderChange = (event: any) => {
    field_metadata.placeholder = event.target.value
    onchange()
  }
  const onInstructionChange = (event: any) => {
    field_metadata.instruction = event.target.value
    onchange()
  }
  const onHelpTextChange = (event: any) => {
    field_metadata.description = event.target.value
    onchange()
  }
  const onMinChange = (event: any, type: any) => {

    if (type == 'min' || type == 'max') {
      schema[type] = getParseFloatValue(event?.target?.value);
    }
    // if (type == 'min') {
    //   // schema.min = event.target.value != undefined && event.target.value != null ? parseFloat(event.target.value) : null
    //   schema.min = getParseFloatValue(event?.target?.value);
    // }
    // if (type == 'max') {
    //   schema.max = getParseFloatValue(event?.target?.value);
    // }
    console.log('onNumber min change', schema.min, schema.max)
    if (!schema.error_details) {
      schema.error_details = {}
    }

    if (event.target.value.length && schema.min > schema.max) {
      schema.error_details = {
        ...schema.error_details,
        max: 'min value cannot be greater than max value'
      }
      schema.error = true
      // } else if (event.target.value.length && schema.min < 0) {
      //   schema.error_details = {
      //     ...schema.error_details,
      //     min: 'min cannot be less then zero'
      //   }
      //   schema.error = true
      // } else if (event.target.value.length && schema.max < 0) {
      //   schema.error_details = {
      //     ...schema.error_details,
      //     max: 'max cannot be less then zero'
      //   }
      //   schema.error = true
    } else {
      console.log('error_details are', schema.error_details)
      schema.error_details = {
        ...schema.error_details,
        max: '',
        min: ''
      }
      schema.error = Object.keys(schema.error_details).filter((fi) => schema.error_details[fi].length).length
        ? true
        : false
    }
    onchange()
  }

  const onOptionsChange = (event: any) => {
    if (event.target.name === `${uniqueKey}.mandatory`) {
      schema.mandatory = event.target.checked
    }
    if (event.target.name === `${uniqueKey}.unique`) {
      schema.unique = event.target.checked
    }
    if (event.target.name === `${uniqueKey}.multiple`) {
      if (event.target.checked) field_metadata.isTitle = false;
      onNumberOptionsChangeMultipleHelper(schema, event.target.checked);
    }
    if (event.target.name === `${uniqueKey}.nonLocalization`) {
      if (event.target.checked && parentInfo.hasParent && hasNonLocalizablePlanForBlocksAndGroupMultiple) {
        handleToggleClick(event, parentInfo.data_type, schema, onchange, 'nonLocalizable', props.t, parentInfo.isInsideMultiple, parentInfo.ancestorWithMultipleType)
      }
      else {
        schema.non_localizable = event.target.checked
      }
    }
    onchange()
  }
  const onDefaultValueChange = (event: any) => {

    field_metadata.default_value = getParseFloatValue(event?.target?.value);

    if (schema.display_name && schema.newfield) {
      schema.uid = schema.display_name
        .trim()
        .replace(/[^A-Z0-9]+/gi, '_')
        .toLowerCase()
      schema.error_details = {
        ...schema.error_details,
        uid: ''
      }
    }

    if (!schema.error_details) {
      schema.error_details = {}
    }

    if (
      field_metadata.default_value
        ? field_metadata.default_value < schema.min || field_metadata.default_value > schema.max
        : false
    ) {
      schema.error_details = {
        ...schema.error_details,
        default_value: 'Default value length not satisfying min/max length'
      }
      schema.error = true
    } else {
      schema.error_details = {
        ...schema.error_details,
        default_value: ''
      }
      schema.error = Object.keys(schema.error_details).filter((fi) => schema.error_details[fi].length).length
        ? true
        : false
    }
    onchange()
  }
  const onMaxInstance = (event: any) => {
    schema.max_instance = event.target.value ? parseInt(event.target.value) : null

    if (!schema.error_details) {
      schema.error_details = {}
    }

    if (event.target.value.length && schema.max_instance < 0) {
      schema.error_details = {
        ...schema.error_details,
        max_instance: 'max instance cannot be less then zero'
      }
      schema.error = true
    } else {
      schema.error_details = {
        ...schema.error_details,
        max_instance: ''
      }
      schema.error = Object.keys(schema.error_details).filter((fi) => schema.error_details[fi].length).length
        ? true
        : false
    }

    onchange()
  }

  if (type === 'basic') {
    return (
      <div className="FormFields">
        <div className="FormFields__column">
          <Field>
            <FieldLabel testId="cs-form-field-number-name" version="v2" required htmlFor="displayName">
              Display Name
            </FieldLabel>
            <TextInput
              required
              version="v2"
              name={`${uniqueKey}.displayName`}
              value={display_name}
              onChange={onDisplayNameChange}
              inputRef={displayNameRef}
              error={schema.error && schema.error_details.display_name ? true : false}
              placeholder={props.t(
                'content_type.save_content_type.body.fields.common_properties.placeholders.enter_value'
              )}
              testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.DISPLAY_NAME_INPUT)}
            />
          </Field>
          <Field>
            <FieldLabel testId="cs-form-field-number-uid" version="v2" required htmlFor="uid">
              Unique ID
            </FieldLabel>
            <Help type="basic" text="A unique ID for this field. This should not be same as the ID of any other field in this content type." />
            <TextInput
              required
              version="v2"
              name={`${uniqueKey}.uid`}
              value={uid}
              onChange={onUidChange}
              error={(schema.error && schema.error_details.uid) || error ? true : false}
              placeholder={props.t(
                'content_type.save_content_type.body.fields.common_properties.placeholders.enter_value'
              )}
              testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.UID_INPUT)}
            />
          </Field>
          <Field>
            <FieldLabel testId="cs-form-field-number-placeholder" version="v2" htmlFor="placeholder">Placeholder Value</FieldLabel>
            <TextInput
              version="v2"
              name={`${uniqueKey}.placeholder`}
              value={field_metadata.placeholder || ''}
              onChange={onPlaceholderChange}
              placeholder={props.t(
                'content_type.save_content_type.body.fields.common_properties.placeholders.enter_value'
              )}
              testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.PLACEHOLDER_INPUT)}
            />
          </Field>
          <Field>
            <FieldLabel testId="cs-form-field-number-instruction" version="v2" htmlFor="instruction">Instruction Value</FieldLabel>
            <Help type="basic" text="Helps you add instructions for this field. The instructional text will appear below the field." />
            <Textarea
              version="v2"
              name={`${uniqueKey}.instruction`}
              value={field_metadata.instruction || ''}
              onChange={onInstructionChange}
              placeholder={props.t(
                'content_type.save_content_type.body.fields.common_properties.placeholders.enter_value'
              )}
              // multiline={true}
              testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.INSTRUCTION_INPUT)}
              id={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.INSTRUCTION_INPUT)}
            />
          </Field>
          <Field>
            <FieldLabel testId="cs-form-field-number-helptext" version="v2" htmlFor="helpText">Help Text</FieldLabel>
            <Help type="basic" text="Provide additional info about the field. The help text will appear when the user hovers on the ‘?’ sign beside the field name." />
            <Textarea
              version="v2"
              showCharacterCount={true}
              hideCharCountError={false}
              maxLength={256}
              name={`${uniqueKey}.helpText`}
              value={field_metadata.description || ''}
              onChange={onHelpTextChange}
              placeholder={props.t(
                'content_type.save_content_type.body.fields.common_properties.placeholders.enter_value'
              )}
              // multiline={true}
              testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.HELP_TEXT_INPUT)}
              id={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.HELP_TEXT_INPUT)}
            />
          </Field>
        </div>
      </div>
    )
  } else if (type === 'advanced') {
    return (
      <div className="FormFields">
        <div className="FormFields__column">
          <Field>
            <FieldLabel testId="cs-form-field-number-range" version="v2" htmlFor="minmax">Range</FieldLabel>
            <div className="FormFields__group-fields">
              <TextInput
                type="number"
                version="v2"
                name={`${uniqueKey}.minimum`}
                value={schema.min != undefined && schema.min != null ? schema.min : ''}
                onKeyDown={(e) => handleKeyDown(e, schema.min)}
                onChange={(e) => onMinChange(e, 'min')}
                error={schema.error && schema.error_details.min ? true : false}
                placeholder={props.t('content_type.save_content_type.body.fields.common_properties.placeholders.min')}
                testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.MIN_RANGE_INPUT)}
              />
              <span className="FormFields__group-separator">to</span>
              <TextInput
                type="number"
                version="v2"
                name={`${uniqueKey}.maximum`}
                onKeyDown={(e) => handleKeyDown(e, schema.max)}
                value={schema.max != undefined && schema.max != null ? schema.max : ''}
                onChange={(e) => onMinChange(e, 'max')} //{onMaxChange}
                error={schema.error && schema.error_details.max ? true : false}
                placeholder={props.t('content_type.save_content_type.body.fields.common_properties.placeholders.max')}
                testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.MAX_RANGE_INPUT)}
              />
            </div>
          </Field>
          <Field>
            <FieldLabel testId="cs-form-field-number-default" version="v2" htmlFor="defaultValue">Default Value</FieldLabel>
            <Help type="basic" text="Set a default field value for this field. The value will appear by default while creating an entry for this content type." />
            <TextInput
              version="v2"
              type="number"
              name={`${uniqueKey}.defaultValue`}
              value={
                field_metadata?.default_value != undefined && field_metadata?.default_value != null
                  ? field_metadata?.default_value
                  : ''
              }
              onKeyDown={(e) => handleKeyDown(e, field_metadata.default_value)}
              onChange={onDefaultValueChange}
              error={schema.error && schema.error_details.default_value ? true : false}
              placeholder={props.t(
                'content_type.save_content_type.body.fields.common_properties.placeholders.enter_value'
              )}
              testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.DEFAULT_VALUE_INPUT)}
            />
          </Field>
        </div>
        <div className="FormFields__column">
          <Field>
            <FieldLabel testId="cs-form-field-number-options" version="v2" htmlFor="options">Options</FieldLabel>
            <div className="FormFields__selection-wrapper">
              <div className="ToggleWrap">
                <ToggleSwitch
                  testId={booleanTestIdFormatter("cs-ct-field-multiline-mandatory", schema.mandatory)}
                  name={`${uniqueKey}.mandatory`}
                  label="Mandatory"
                  checked={schema.mandatory}
                  onChange={onOptionsChange}
                />
              </div>
              {/* <Checkbox
                testId="cs-ct-field-number-mandatory"
                name={`${uniqueKey}.mandatory`}
                text="Mandatory"
                checked={schema.mandatory}
                onChange={onOptionsChange}
              /> */}
              {!options.singleton &&
                (parentInfo.hasParent
                  ? parentInfo.data_type == 'group' || parentInfo.data_type == 'global_field'
                  : true) ? (
                isCTBuilder ? (
                  <div className="ToggleWrap">
                    <ToggleSwitch
                      testId={booleanTestIdFormatter("cs-ct-field-number-unique", schema.unique)}
                      name={`${uniqueKey}.unique`}
                      label="Unique"
                      checked={schema.unique}
                      onChange={onOptionsChange}
                    />
                  </div>
                  // <Checkbox
                  //   testId="cs-ct-field-number-unique"
                  //   name={`${uniqueKey}.unique`}
                  //   text="Unique"
                  //   checked={schema.unique}
                  //   onChange={onOptionsChange}
                  // />
                ) : null
              ) : null}
              <div className="ToggleWrap">
                <ToggleSwitch
                  testId={booleanTestIdFormatter("cs-ct-field-number-multiple", schema.multiple)}
                  name={`${uniqueKey}.multiple`}
                  label="Multiple"
                  checked={schema.multiple}
                  onChange={onOptionsChange}
                />
              </div>
              {/* <Checkbox
                testId="cs-ct-field-number-multiple"
                name={`${uniqueKey}.multiple`}
                text="Multiple"
                checked={schema.multiple}
                onChange={onOptionsChange}
              /> */}
              {schema.multiple ? (
                hasUserCustomFieldLimitRestFields ? (
                  <CustomUserLimit
                    uniqueKey={uniqueKey}
                    schema={schema}
                    onchange={onchange}
                    t={props.t}
                    type={type}
                  />
                ) : (
                  <div className="FormFields__with-max-limit">
                    <Field>
                      <FieldLabel testId="cs-form-field-number-max-limit" version="v2" className="ml-0" htmlFor="validation">
                        Set Maximum Limit
                      </FieldLabel>
                      <TextInput
                        type="number"
                        version="v2"
                        name={`${uniqueKey}.maxinstance`}
                        value={schema.max_instance || null}
                        onChange={onMaxInstance}
                        placeholder={props.t(
                          'content_type.save_content_type.body.fields.common_properties.placeholders.maximum'
                        )}
                        error={schema.error && schema.max_instance ? true : false}
                        testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.SET_MAX_LIMIT_INPUT)}
                      />
                    </Field>
                  </div>
                )
              ) : null}
              {
                hasNonLocalizablePlan ? (
                  hasNonLocalizablePlanForBlocksAndGroupMultiple ? (
                    <NonLocalizableDom
                      isFieldPresent={true}
                      uniqueKey={uniqueKey}
                      schema={schema}
                      onOptionsChange={onOptionsChange}
                      dataTestId={booleanTestIdFormatter(schema.nonLocParams?.insideMultiple ? `cs-ct-field-number-non-localizable-parent-multiple` : `cs-ct-field-number-non-localizable`, schema.non_localizable)}
                      dataTestIdForDescription={"cs-ct-field-number-non-localizable-description"}
                      isNonLocalizable={isNonLocalizable}
                      isAncestorNonLoc={parentInfo.isAncestorNonLoc}
                      userCustomFieldLimits={{ hasUserCustomFieldLimit, hasUserCustomFieldLimitRestFields}}
                    />
                  ) : (parentInfo.hasParent ? !parentInfo.isInsideMultiple : true) ?
                    <NonLocalizableDom
                      isFieldPresent={true}
                      uniqueKey={uniqueKey}
                      schema={schema}
                      onOptionsChange={onOptionsChange}
                      dataTestId={booleanTestIdFormatter("cs-ct-field-number-non-localizable", schema.non_localizable)}
                      dataTestIdForDescription={"cs-ct-field-number-non-localizable-description"}
                      isNonLocalizable={isNonLocalizable}
                      isAncestorNonLoc={parentInfo.isAncestorNonLoc}
                      userCustomFieldLimits={{ hasUserCustomFieldLimit, hasUserCustomFieldLimitRestFields}}
                    />
                    : null
                ) : null
              }
            </div>
          </Field>
          <GroupFieldTitleToggle
            parentInfo={parentInfo}
            uniqueKey={uniqueKey}
            field_metadata={field_metadata}
            onchange={onchange}
            multiple={schema?.multiple}
            testId="cs-ct-field-number-group-title"
          />
          <GlobalFieldTitleToggle
            parentInfo={parentInfo}
            uniqueKey={uniqueKey}
            field_metadata={field_metadata}
            onchange={onchange}
            multiple={schema?.multiple}
            testId="cs-ct-field-number-global-title"
            schema={schema}
            contentTypeSchemaTree={contentTypeSchemaTree}
            isGlobalFieldBuilderPage={isGlobalFieldBuilderPage}
          />
          <ModularBlockInstanceTitleToggle
            parentInfo={parentInfo}
            uniqueKey={uniqueKey}
            field_metadata={field_metadata}
            onchange={onchange}
            multiple={schema?.multiple}
            testId="cs-ct-field-number-modular-block-instance-title"
            schema={schema}
          />
        </div>
      </div>
    )
  }
}

export default React.memo(Number)
